// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2X2Cn","list":"PatternAutocomplete_list__349x-"};